import React from "react";

export default function QuestionHeatmap({ data }) {
  const xLabels = data?.xLabels || [];
  const yLabels = data?.yLabels || [];
  const valueMap = data?.valueMap || new Map();
  const min = data?.min ?? 0;
  const max = data?.max ?? 0;

  // Render horizontally: cols = hours (yLabels)
  const cols = yLabels.length;

  // Legend colors
  const colors = ["#F9FAFB", "#C5ECB2", "#56C364", "#11865B"];
  const gapPx = 4;

  const colorFor = (v) => {
    if (max === min) return colors[0];
    const n = (v - min) / (max - min);
    if (n > 0.75) return colors[3];
    if (n > 0.5) return colors[2];
    if (n > 0.25) return colors[1];
    return colors[0];
  };

  return (
    <div className="bg-white p-6 min-h-[330px] w-full min-w-0 rounded-2xl shadow-sm border border-gray-200">
      <h3 className="font-bold text-lg text-gray-900">Question Source Heatmap</h3>
      <p className="text-xs text-gray-500 mt-1">
        Actions or important observations suggested by the system
      </p>
      <div className="mt-4 rounded-xl border border-gray-100 p-4 overflow-hidden">
        <div
          className="grid mx-auto w-full"
          style={{
            gridTemplateColumns: `repeat(${cols || 1}, minmax(0, 1fr))`,
            gap: `${gapPx}px`
          }}
        >
          {xLabels.length === 0 || yLabels.length === 0 ? (
            <div className="text-xs text-gray-500">No data available</div>
          ) : xLabels.map((x) =>
            yLabels.map((y) => {
              const v = valueMap.get(`${x}__${y}`) ?? 0;
              return (
                <div
                  key={`${x}-${y}`}
                  className="rounded-sm"
                  style={{
                    width: "100%",
                    aspectRatio: "1 / 1",
                    backgroundColor: colorFor(v)
                  }}
                />
              );
            })
          )}
        </div>
        <div className="mt-4 flex items-center gap-4 text-[11px] text-gray-600">
          {colors.map((color, index) => (
            <span key={index} className="inline-flex items-center gap-1">
              Less
              <span
                className="h-2 w-2 rounded-sm"
                style={{ backgroundColor: color }}
              ></span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
